/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchAccounts.defs.js'
export { main as default } from './searchAccounts.defs.js'
